import React from 'react';
import {TableBody, TableRow,} from '@mui/material';
import { withStyles } from "@mui/styles";
import {useHistory} from 'react-router-dom';

export const openLinkStyle = (mod) => {
  let styles = {
    cursor:'pointer',
    '&:hover':{
      opacity:0.65
    }
  };
  styles['& ' + mod + ' > svg'] = {
      backgroundColor: 'rgba(255, 255, 255, 0.75)',
      padding: '0px',
      opacity: '0.8',
      margin: '1px',
      display:'none',
      position:'absolute',
      right: '0px',
      top:'0px'
    };
  styles['&:hover ' + mod + ' > svg'] = { display:'inline-block' };
  styles['&:hover'] = { opacity:0.65 };
  if(!mod || mod === ''){
    styles['position'] = 'relative';
  }
  return styles;
};

const styles = {
  checkbox:{
    width: '42px',
    maxWidth: '42px',
    boxSizing: 'border-box',
    padding: '0 !important',
  },
  icons:{
    verticalAlign: 'middle',
    display:'flex',
    flexDirection:'row',
    flexWrap:'nowrap',
    flex: 0,
  },
  typeIcon:{
    color: '#005985',
    padding:'3px 0'
  },
  pendingButton:{
  },
  pendingPlaceholder:{
    // width:'calc(1.5rem + 6px)',
    // height:'calc(1.5rem + 6px)',
  },
  pendingIcon: {
    color: '#ffb506',
    // width: '18px',
    // height: '18px'
  },
  rowIcon: {
    display: 'inline-block',
    width: 40,
    height: 40,
    verticalAlign: 'text-bottom',
    textAlign: 'right'
  },
  openLink: {
    ...openLinkStyle(''),
    fontWeight: '500',
    color: 'rgba(0,0,0,0.8)',
    width:'10dvw',
    minWidth: '8em',
    maxWidth: 'calc(max(10dvw, 15em))',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textDecoration:'underline'
  },
  openLinkIcon: {
    ...openLinkStyle('+ td'),
    width: '56px',
    maxWidth: '56px'
  },
  typeCellSm: {
    maxWidth: '32px',
    minWidth: '32px',
    width: '32px',
  },
  typeCell: {
    maxWidth: '54px',
    width: '52px',
  },
  descriptionCell: {
    maxWidth: 'calc(max(100%,9dvw) )',
    minWidth: '12em',
    height: '3rem',
    maxHeight: '3rem',
  },
  descriptionText: {
    maxHeight:'100%',
    fontSize:'0.85em',
    fontWeight:'300',
    overflow: 'hidden',
    lineHeight:'1.33em',
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical'
  },
  descriptionCellSingle: {
    maxWidth: 'calc(max(100%,9dvw))',
    minWidth: '12em',
    fontSize: "1.125rem",
    // whiteSpace:'nowrap',
    overflow: 'hidden',
    textOverflow:'ellipsis',
  },
  locationCell: {
    maxWidth:'calc(max(9dvw,12em))',
    width: '6dvw',
    whiteSpace:'nowrap',
    minWidth:'5em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  locationText: {
    whiteSpace:'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  folderCell: {
    whiteSpace:'nowrap',
    width:'6dvw',
    maxWidth:'calc(max(6dvw,10em))',
    minWidth:'5em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textDecoration:'underline',
    ...openLinkStyle(''),
  },
  tagCell: {
    width:'5em',
    minWidth: '4em',
    maxWidth: 'calc(max(5em, min(15em, 30dvw)))',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tagCellSm: {
    whiteSpace:'nowrap',
    width:'3em',
    overflow:'hidden',
    textOverflow:'ellipsis',
    maxWidth:'calc(max(3dvw,4em))',
    fontSize:'0.7225em',
    fontWeight:600,
    opacity:0.65,
  },
  tagCellAction: {
    whiteSpace:'nowrap',
    width:'5em',
    overflow:'hidden',
    textOverflow:'ellipsis',
    textDecoration:'underline',
    cursor:'pointer',
    '&:hover':{
      opacity:0.65
    }
  },
  tagListCell: {
    width:'7dvw',
    maxWidth:'calc(max(9dvw,11em))',
    height: '3rem',
    maxHeight: '3rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding:'0px 8px',
    boxSizing: "border-box"
  },
  tagListInner: {
    // maxHeight:'100%',
    display: 'flex',
    position:'relative',
    flexWrap: 'wrap',
    // alignItems: 'center',
    '& > *:nth-child(2)':{
      display: 'flex',
      position:'relative',
      flexWrap: 'wrap',
      overflow: 'hidden',
      maxHeight: '3rem',
      gap: '0 6px',
      '& > div:first-child': {
        marginLeft: '2em',
      }
    }
  },
  tagListItem: {
    display:'inline-block',
    fontSize:'0.85em',
    whiteSpace:'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis'
  },
  tagListActionItem: {
    display:'inline-block',
    fontSize:'0.85em',
    whiteSpace:'nowrap',
    textDecoration:'underline',
    overflow:'hidden',
    textOverflow:'ellipsis',
    cursor:'pointer',
    '&:hover':{
      opacity:0.65
    }
  },
  tagListCount: {
    display:'inline-block',
    position:'absolute',
    marginTop: '2px',
    fontSize:'11px',
    lineHeight:'12px',
    backgroundColor:'#eee',
    borderRadius:'8px',
    border:'1px solid #cecece',
    padding:'0px 3px',
    textAlign:'center'
  },
  cellSubtext:{
    fontSize:'0.85em',
    whiteSpace:'nowrap',
    fontWeight:'300',
    lineHeight: '1em'
  },
  sizeLabel:{
    fontSize:'0.825em',
    whiteSpace:'nowrap',
    marginLeft:'0.35em'
  },
};

function DataListView(props) {
  const { columns, visibleColumns, itemList, selectedItems, onSelectItem, openDataView, mindfileUserLevel, classes } = props;

  const history = useHistory();

  return (
      <TableBody id="dataTableListRows"
              color="secondary">
        {itemList.map((item, index) => {
          const isSelected = mindfileUserLevel <= 2 && !!selectedItems[item.id];
          return (
            <TableRow key={item.id}
              onClick={() => onSelectItem(item)}
              color="secondary"
              role="checkbox"
              tabIndex={-1}
              selected={isSelected}
            >
              {columns.filter(column => column.enabled && visibleColumns[column.key] && (mindfileUserLevel <= 2 || column.key !== "selected")).map((column) =>
                column.cell(
                  `${column.key}`,
                  item,
                  isSelected,
                  openDataView.bind(this, item.id),
                  classes,
                  history,
                  column
                )
              )}
            </TableRow>
        );
      })}
      </TableBody>
    );
}

export default withStyles(styles)(DataListView);
